module.exports = __webpack_public_path__ + "img/zizhi0.57932cec.png";